import "./App.css";
import React from "react";
import HomePage from "./pages/HomePage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuctionPage from "./pages/AuctionPage";
import Layout from "./components/Layout";
import PollPopup from "./components/PollPopup";
import LoginPage from "./pages/LoginPage";
import LoginUaePassPage from "./pages/LoginUaePassPage";
import LoginUaePassPageOTP from "./pages/LoginUaePassPageOTP";
import RegisterPage from "./pages/RegisterPage";
import AuctionDetailsPage from "./pages/AuctionDetailsPage";
import HorseProfile from "./pages/HorseProfile";
import BiddingPage from "./pages/BiddingPage";
import StudBookPage from "./pages/StudBookPage";
import OwnerProfile from "./pages/OwnerProfile";
import OwnerDetailsPage from "./pages/OwnerDetailsPage";
import HorseDetailsPage from "./pages/HorseDetailsPage";
import HorseMarket from "./pages/HorseMarket";
import HorseMarketProfile from "./pages/HorseMarketProfile";
import ForgetPasswordPage from "./pages/ForgetPasswordPage";
import SingleServicePage from "./pages/SingleServicePage";
import SinglePost from "./pages/SinglePost";
import AboutUs from "./pages/AboutUs";
import NewsPage from "./pages/NewsPage";
import HorseSupplies from "./pages/HorseSupplies";
import SingleSupplier from "./pages/SingleSupplier";
import SingleTransportCompany from "./pages/SingleTransportCompany";
import HorseTransportCompanies from "./pages/HorseTransportCompanies";
import EquestrianCentersClubs from "./pages/EquestrianCentersClubs";
import SingleEquestrianCentersClubs from "./pages/SingleEquestrianCentersClubs";
import ContactUs from "./pages/ContactUs";
import ServicesPage from "./pages/ServicesPage";
import OrgChartPage from "./pages/OrgChartPage";
import Shows from "./pages/Shows";
import ShowDetails from "./pages/ShowDetails";
import WahoConference from "./pages/WahoConference";
import ShowEntryCard from "./pages/ShowEntryCard";
import ScrollToTop from "./components/scroll-to-top";
import CalendarPage from "./pages/CalendarPage";
import ShowEntryDetails from "./pages/ShowEntryDetails";
import AddRegisterHorse from "./pages/AddRegisterHorse";
import ShowEntryConflict from "./pages/ShowEntryConflict";
import ShowEntryTotalRegisteredHorses from "./pages/ShowEntryTotalRegisteredHorses";
import ShowEntryParticipantsRequest from "./pages/ShowEntryParticipantsRequest";
import ShowEntrySubmissionSuccessful from "./pages/ShowEntrySubmissionSuccessful";
import GalleryPage from "./pages/GalleryPage";
import AlbumPage from "./pages/AlbumPage";
import WahoTrophy from "./pages/WahoTrophy";
import BookTable from "./pages/BookTable";
import ShowsCategories from "./pages/ShowsCategories";
import AuctionEntryCard from "./pages/AuctionEntryCard";
import Auctionentrytotalregisteredhorses from "./pages/AuctionEntryTotalRegisteredHorses";
import AuctionEntrySubmissionSuccessful from "./pages/AuctionEntrySubmissionSuccessful";
import BookingSubmissionSuccessful from "./pages/BookingSubmissionSuccessful";
import OpendBooking from "./pages/OpendBooking";
import RequestHorseOwnershipTransferSeller from "./pages/RequestHorseOwnershipTransferSeller";
import HorseLeasingRequestPage from "./pages/services/HorseLeasing/pages/HorseLeasingRequestPage";
import ServicesRequestsPaymentSuccessful from "./pages/ServicesRequestsPaymentSuccessful";
import ComingSoon from "./components/ComingSoon";
import SingleHospital from "./pages/SingleHospital";
import HorseHospitals from "./pages/HorseHospitals";
import CoursesPage from "./pages/CoursesPage";
import SponsersPage from "./pages/SponsersPage";
import SingleTermsAndConditionsShowPage from "./pages/SingleTermsAndConditionsShowPage";
import EducationalPage from "./pages/EducationalPage";
import AddOrganizerRequest from "./pages/AddOrganizerRequest";
import LiveStream from "./pages/LiveStream";
import RequestCoveringCertificate from "./pages/RequestCoveringCertificate";
import InternationalBreedingCertificateRequestPage from "./pages/services/internationalBreedingCertificate/pages/InternationalBreedingCertificateRequestPage";
import AwardPage from "./pages/AwardPage";
import { toast, ToastContainer } from "react-toastify";
import ShowCatalog from "./pages/ShowCatalog";
import RequestEmbryoOocyteTransferPermit from "./pages/RequestEmbryoOocyteTransferPermit";
import LiveBiddingScreen from "./pages/LiveBiddingScreen";
import HybridBiddingPage from "./pages/HybridBiddingPage";
import RequestEmbryoTransferRightPurchaceAgreement from "./pages/RequestEmbryoTransferRightPurchaceAgreement";
import RequestRegisteringNewArabianHorseFoal from "./pages/RequestRegisteringNewArabianHorseFoal";
import RequestForOwnedEAHSRegisteredHorsesCertificate from "./pages/RequestForOwnedEAHSRegisteredHorsesCertificate";
import RequestForRegistrationOfAnArabianHorseStud from "./pages/RequestForRegistrationOfAnArabianHorseStud";
import RequestToUpdateArabianHorseData from "./pages/RequestToUpdateArabianHorseData";
import PressCoverageRequest from "./pages/PressCoverageRequest";
import RequestToDeclarationOfArabianHorseDeath from "./pages/RequestToDeclarationOfArabianHorseDeath";
import InactiveHorseRegistrationRequest from "./pages/InactiveHorseRegistrationRequest";
import RequestToAddARacingNameForAnImportedArabianHorse from "./pages/RequestToAddARacingNameForAnImportedArabianHorse";
import ReqestForIssuingAnArabianHorsePassportDuplicateDamaged from "./pages/ReqestForIssuingAnArabianHorsePassportDuplicateDamaged";
import ImportHorseFrozenSemen from "./pages/ImportHorseFrozenSemen";
import OpenApp from "./pages/OpenApp";
import AddFoalHorse from "./pages/AddFoalHorse";
import ImportHorse from "./pages/ImportHorse";
import GeneticDisorderTesting from "./pages/GeneticDisorderTesting";
import UAEOfficialsPage from "./pages/UAEOfficialsPage.js";
import RequestSemenCertificate from "./pages/RequestSemenCertificate";
import ExportHorse from "./pages/ExportHorse";
import ShowParticipatePage from "./pages/showEntry/ShowParticipatePage";
import AddInternationalHorse from "./pages/showEntry/AddInternationalHorse";
import ShowEntryCheckoutPage from "./pages/showEntry/ShowEntryCheckoutPage";
import CoursesNewPage from "./pages/CoursesNewPage";
import CourseEnrollment from "./pages/CourseEnrollment";
import AuctionDetails from "./pages/auctionDetails/AuctionDetails";
import PresidentWord from "./pages/PresidentWord";
import CancelExportHorse from "./pages/CancelExportHorse";
import ExportHorseSemen from "./pages/ExportHorseSemen";
import LibraryPage from "./pages/EahsLibrary/LibraryPage.js";
import RoutesName from './RoutesName.js'
import { useLocation } from "react-router-dom/dist/index.js";
import AucitonEntryParticipate from "./pages/AuctionEntry/AuctionEntryParticipate/AucitonEntryParticipate.js";
import AuctionEntryCheckoutPage from "./pages/AuctionEntry/AuctionEntryCheckoutPage.js";
import CourseEnrollmentDate from "./pages/CourseEnrollmentDate.js";
import ChulibPage from "./pages/CholibShow/ChulibPage.js";
import PrivateRoute from "./PrivateRoute.js";
import OwnerServicesForm from "./pages/ownersServices/OwnerServicesForm.js";
import FontCompetitionPage from "./pages/fontCompetition/FontCompetitionPage.js";
import SemenMarketListPage from "./pages/seminMarket/Pages/SemenMarketListPage.js";
import SemenDetailsPage from "./pages/seminMarket/Pages/SemenDetailsPage.js";
import SemenCheckoutPage from "./pages/seminMarket/Pages/SemenCheckoutPage.js";
import SemenRequestsPage from "./pages/seminMarket/Pages/SemenRequestsPage.js";
import HorseMarketListPage from "./pages/horseMarket/Pages/HorseMarketListPage.js";
import HorseMarketDetailsPage from "./pages/horseMarket/Pages/HorseMarketDetailsPage.js";
import DigitalCatalog from "./pages/DigitalCatalog.js";
import DisciplinaryDecisionsListPage from "./pages/disciplinaryDecisions/Pages/DisciplinaryDecisionsListPage.js";
import DisciplinaryDecisionDetailsPage from "./pages/disciplinaryDecisions/Pages/DisciplinaryDecisionDetailsPage.js";
import CompleteProfileMiddleWare from "./CompleteProfileMiddleWare.js";
import PollPage from "./pages/PollPage.js";
import WorkshopRegistrationPage from "./pages/workshopRegistration/WorkshopRegistrationPage.js";
function App() {
  const dismissAll = () => toast?.dismiss();
  const ShowsCategoriesID = process.env.REACT_APP_SHOWS_CATEFORIES_ID;
  const NoneEcahoShowsCategoriesID = process.env.REACT_APP_NONE_ECAHO_SHOWS_CATEFORIES_ID;

  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.has("eahsLang")
    ? searchParams.get("eahsLang")
    : searchParams.has("eahslang") ? searchParams.get("eahslang") : null;
  const currentLang = localStorage.getItem('eahsLang') ?? 'en';
  if (!!lang) {
    if (currentLang != lang) {
      localStorage.setItem('eahsLang', lang);
      window.location.reload();
    }
  }

  return (
    <Router basename="/">
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      <Layout>
        <PollPopup />
        <CompleteProfileMiddleWare>
          <Routes>
            <Route path={RoutesName.HOME} element={<HomePage key={'HomePage'} />} />
            <Route path={RoutesName.STUDBOOK} element={<StudBookPage key={'StudBookPage'} />} />
            <Route path={RoutesName.AUCTIONS} element={<AuctionPage key={'AuctionPage'} />} />
            <Route path={RoutesName.SINGLE_AUCTION} element={<AuctionDetailsPage key={'AuctionDetailsPage'} />} />
            <Route path={RoutesName.AUCTION} element={<AuctionDetails key={'AuctionDetails'} toast={toast} />} />
            <Route path={RoutesName.OWNER_DETAILS} element={<OwnerDetailsPage key={'OwnerDetailsPage'} />} />
            <Route path={RoutesName.HORSE_DETAILS} element={<HorseDetailsPage key={'HorseDetailsPage'} />} />
            <Route path={RoutesName.HORSE_MARKET_PROFILE} element={<HorseMarketProfile key={'HorseMarketProfile'} />} />
            <Route path={RoutesName.LOGIN} element={<LoginPage key={'LoginPage'} />} />
            <Route path={RoutesName.LOGIN_UAE_PASS} element={<LoginUaePassPage key={'LoginUaePassPage'} />} />
            <Route path={RoutesName.UAE_PASS_OTP} element={<LoginUaePassPageOTP key={'LoginUaePassPageOTP'} />} />
            <Route path={RoutesName.REGISTER} element={<RegisterPage key={'RegisterPage'} />} />
            <Route path={RoutesName.HORSE_AUCTION} element={<HorseProfile key={'HorseProfile'} />} />
            <Route path={RoutesName.BIDDING} element={<BiddingPage key={'BiddingPage'} />} />
            <Route path={RoutesName.FULL_SCREEN_BIDDING} element={<LiveBiddingScreen key={'LiveBiddingScreen'} />} />
            <Route path={RoutesName.HYBRID_BIDDING} element={<HybridBiddingPage toast={toast} />} />
            <Route path={RoutesName.PROFILE}
              element={
                <PrivateRoute>
                  <OwnerProfile />
                </PrivateRoute>
              }
            />
            <Route path={RoutesName.HORSE_MARKET} element={<HorseMarketListPage key={'HorseMarketList'} toast={toast} />} />
            <Route path="/horseMarket" element={<HorseMarketListPage key={'HorseMarketListAlt'} toast={toast} />} />
            <Route path={RoutesName.HORSE_MARKET_DETAILS} element={<HorseMarketDetailsPage key={'HorseMarketDetails'} toast={toast} />} />
            <Route path={RoutesName.SHOWS} element={<Shows key={'Shows'} />} />
            <Route path={RoutesName.SHOW_DETAILS} element={<ShowDetails key={'ShowDetails'} />} />
            <Route path={RoutesName.FORGET_PASSWORD} element={<ForgetPasswordPage key={'ForgetPasswordPage'} />} />
            <Route path={RoutesName.SINGLE_SERVICE} element={<SingleServicePage key={'SingleServicePage'} />} />
            <Route path={RoutesName.SINGLE_POST} element={<SinglePost key={'SinglePost'} />} />
            <Route path={RoutesName.ABOUT_US} element={<AboutUs key={'AboutUs'} />} />
            <Route path={RoutesName.NEWS} element={<NewsPage key={'NewsPage'} />} />
            <Route path={RoutesName.HORSE_SUPPLIES} element={<HorseSupplies key={'HorseSupplies'} />} />
            <Route path={RoutesName.SINGLE_SUPPLIER} element={<SingleSupplier key={'SingleSupplier'} />} />
            <Route path={RoutesName.UAEOfficials} element={<UAEOfficialsPage key={'UAEOfficialsPage'} />} />
            <Route path={RoutesName.PRESIDENT_WORD} element={<PresidentWord key={'PresidentWord'} />} />
            <Route path={RoutesName.LIBRARY_PAGE} element={<LibraryPage key={'LibraryPage'} />} />

            <Route
              path={RoutesName.HORSE_TRANSPORT_COMPANIES}
              element={<HorseTransportCompanies key={'HorseTransportCompanies'} />}
            />
            <Route
              path={RoutesName.SINGLE_TRANSPORT_COMPANY}
              element={<SingleTransportCompany key={'SingleTransportCompany'} />}
            />
            <Route path={RoutesName.HORSE_HOSPITALS} element={<HorseHospitals key={'HorseHospitals'} />} />
            <Route path={RoutesName.SINGLE_HOSPITAL} element={<SingleHospital key={'SingleHospital'} />} />
            <Route
              path={RoutesName.EQUESTRIAN_CENTERS_CLUBS}
              element={<EquestrianCentersClubs key={'EquestrianCentersClubs'} />}
            />
            <Route
              path={RoutesName.SINGLE_EQUESTRIAN_CENTERS_CLUBS}
              element={<SingleEquestrianCentersClubs key={'SingleEquestrianCentersClubs'} />}
            />
            <Route path={RoutesName.CONTACT_US} element={<ContactUs key={'ContactUs'} />} />
            <Route path={RoutesName.SERVICES} element={<ServicesPage key={'ServicesPage'} />} />
            <Route path={RoutesName.ORG_CHART} element={<OrgChartPage key={'OrgChartPage'} />} />
            <Route path={RoutesName.WAHO_CONFERENCE} element={<WahoConference key={'WahoConference'} />} />
            <Route path="/m-wahoconference" element={<WahoConference key={'WahoConference'} />} />
            <Route path={RoutesName.SHOW_ENTRY_CARD} element={<ShowEntryCard key={'ShowEntryCard'} />} />
            <Route path={RoutesName.CALENDAR} element={<CalendarPage key={'CalendarPage'} />} />
            <Route path={RoutesName.ADD_EARLY_YEARLING_HORSE} element={<AddFoalHorse key={'add foal Horse'} toast={toast} />} />
            <Route
              path={RoutesName.SHOW_ENTRY_DETAILS}
              element={

                <PrivateRoute>
                  <ShowEntryDetails key={'ShowEntryDetails'} toast={toast} />
                </PrivateRoute>

              } />
            <Route path={RoutesName.ADD_REGISTER_HORSE} element={<AddRegisterHorse key={'AddRegisterHorse'} />} />
            <Route path={RoutesName.SHOW_ENTRY_CONFLICT} element={<ShowEntryConflict key={'ShowEntryConflict'} />} />
            <Route path={RoutesName.COURSES} element={<CoursesNewPage key={'CoursesNewPage'} />} />
            <Route path={RoutesName.COURSE_DETAILS} element={<CoursesPage key={'courseDetails'} />} />
            <Route path={RoutesName.COURSE_ENROLLMENT} element={<CourseEnrollment key={'courseEnrollment'} toast={toast} />} />
            <Route path={RoutesName.COURSE_ENROLLMENT_DATE} element={<CourseEnrollmentDate key={'courseEnrollmentDate'} toast={toast} />} />
            <Route path={RoutesName.SPONSORS_PAGE} element={<SponsersPage key={'SponsersPage'} />} />
            <Route
              path={RoutesName.SHOW_ENTRY_TOTAL_REGISTERED_HORSES}
              element={<ShowEntryTotalRegisteredHorses key={'ShowEntryTotalRegisteredHorses'} />}
            />
            <Route
              path={RoutesName.SHOW_ENTRY_PARTICIPANTS_REQUEST}
              element={<ShowEntryParticipantsRequest key={'ShowEntryParticipantsRequest'} />}
            />
            <Route
              path={RoutesName.SHOW_ENTRY_SUBMISSION_SUCCESSFUL}
              element={<ShowEntrySubmissionSuccessful key={'ShowEntrySubmissionSuccessful'} />}
            />
            <Route path={RoutesName.GALLERY} element={<GalleryPage key={'GalleryPage'} />} />
            <Route path={RoutesName.ALBUM_DETAILS} element={<AlbumPage key={'AlbumPage'} />} />
            <Route path={RoutesName.WAHO_TROPHY} element={<WahoTrophy key={'WahoTrophy'} />} />
            <Route path={RoutesName.BOOK_TABLE} element={<BookTable key={'BookTable'} />} />
            <Route path={RoutesName.ADS_BOOK_TABLE} element={<BookTable isAds={true} />} />
            {/* 
              ===== IMPORTANT: Route Swap Configuration =====
              
              These two routes control which booking page shows data and which shows "Coming Soon".
              Only ONE configuration should be active at a time.

              --- Configuration A (Currently Active) ---
              OPEND_EVENTS → OpendBooking (no isAds)  →  "Table Reservation Packages" shows data
              OPEND_ADS    → OpendBooking (isAds=true) →  "Advertising Packages" shows data

              --- Configuration B (Currently Commented Out) ---
              OPEND_ADS    → OpendBooking (no isAds)  →  "Advertising Packages" shows data
              OPEND_EVENTS → OpendBooking (isAds=true) →  "Table Reservation Packages" shows data

              Swap between A and B to toggle which page in the header menu 
              displays data and which one shows "Coming Soon".

              You need to review book table button in show details page also.
            */}
            <Route path={RoutesName.OPEND_EVENTS} element={<OpendBooking key="events" />} />
            <Route
              path={RoutesName.OPEND_ADS}
              element={<OpendBooking isAds={true} key="ads" />}
            />
            {/* Configuration B (uncomment to activate, and comment out Configuration A above):
            <Route path={RoutesName.OPEND_ADS} element={<OpendBooking key="events" />} />
            <Route
              path={RoutesName.OPEND_EVENTS}
              element={<OpendBooking isAds={true} key="ads" />}
            />
            */}
            <Route path={RoutesName.SHOWS_CATEGORIES} element={<ShowsCategories key={RoutesName.SHOWS_CATEGORIES} ShowsCategoriesID={ShowsCategoriesID} />} />
            <Route path={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES} element={<ShowsCategories key={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES} hasHTML={true} ShowsCategoriesID={NoneEcahoShowsCategoriesID} />} />
            <Route path={RoutesName.AUCTION_ENTRY_CARD} element={<AuctionEntryCard key={'AuctionEntryCard'} />} />
            <Route path={RoutesName.EAHS_AWARD} element={<AwardPage key={'AwardPage'} />} />
            <Route path={RoutesName.OPEN_APP_OR_STORE} element={<OpenApp key={'OpenApp'} />} />
            <Route
              path={RoutesName.AUCTION_ENTRY_TOTAL_REGISTERED_HORSES}
              element={<Auctionentrytotalregisteredhorses key={'Auctionentrytotalregisteredhorses'} />}
            />
            <Route
              path={RoutesName.AUCTION_ENTRY_SUBMISSION_SUCCESSFUL}
              element={<AuctionEntrySubmissionSuccessful key={'AuctionEntrySubmissionSuccessful'} />}
            />
            <Route
              path={RoutesName.BOOKING_SUCCESSFUL}
              element={<BookingSubmissionSuccessful key={'BookingSubmissionSuccessful'} />}
            />
            <Route
              path={RoutesName.REQUEST_HORSE_OWNERSHIP_TRANSFER_SELLER}
              element={<RequestHorseOwnershipTransferSeller key={'RequestHorseOwnershipTransferSeller'} />}
            />
            <Route
              path={RoutesName.HORSE_LEASING_REQUEST}
              element={
                <PrivateRoute>
                  <HorseLeasingRequestPage key={'HorseLeasingRequestPage'} />
                </PrivateRoute>
              }
            />
            <Route
              path={RoutesName.SERVICES_REQUESTS_PAYMENT_SUCCESSFUL}
              element={<ServicesRequestsPaymentSuccessful key={'ServicesRequestsPaymentSuccessful'} />}
            />
            <Route path={RoutesName.EDUCATIONAL_COURSES} element={<EducationalPage key={'EducationalPage'} />} />
            <Route path={RoutesName.ADD_INTERNATIONAL_HORSE} element={<AddInternationalHorse key={'addInternationalHorse'} toast={toast} />} />
            <Route path={RoutesName.SHOW_ENTRY_CHECKOUT_PAGE} element={<ShowEntryCheckoutPage key={'ShowEntryCheckoutPage'} toast={toast} />} />
            <Route
              path={RoutesName.SINGLE_TERMS_AND_CONDITIONS_SHOW_PAGE}
              element={<SingleTermsAndConditionsShowPage key={'SingleTermsAndConditionsShowPage'} />}
            />
            <Route
              path={RoutesName.ADD_ORGANIZER_REQUEST}
              element={<AddOrganizerRequest key={'AddOrganizerRequest'} />}
            />
            <Route path={RoutesName.SHOW_CATALOG} element={<ShowCatalog key={'ShowCatalog'} />} />
            <Route path={RoutesName.NOT_FOUND_404} element={<ComingSoon key={'ComingSoon'} />} />
            <Route path={RoutesName.NOT_AUTHORIZED_403} key={'not Auth'} element={<ComingSoon key={'not authrized'} text="web.notAuthrized" defaultText="Not Authrized" />} />
            <Route path={RoutesName.LIVE_EVENT} element={<LiveStream key={'LiveStream'} />} />
            <Route
              path={RoutesName.REQUEST_COVERING_CERTIFICATE}
              element={<RequestCoveringCertificate key={'RequestCoveringCertificate'} />}
            />
            <Route
              path={RoutesName.INTERNATIONAL_BREEDING_CERTIFICATE}
              element={
                <PrivateRoute>
                  <InternationalBreedingCertificateRequestPage key={'InternationalBreedingCertificate'} />
                </PrivateRoute>
              }
            />
            <Route
              path={RoutesName.REQUEST_EMBRYO_OOCYTE_TRANSFER_PERMIT}
              element={<RequestEmbryoOocyteTransferPermit key={'RequestEmbryoOocyteTransferPermit'} />}
            />
            <Route
              path={RoutesName.REQUEST_EMBRYO_TRANSFER_RIGHT_PURCHASE_AGREEMENT}
              element={<RequestEmbryoTransferRightPurchaceAgreement key={'RequestEmbryoTransferRightPurchaceAgreement'} />}
            />
            <Route
              path={RoutesName.REQUEST_REGISTERING_NEW_ARABIAN_HORSE_FOAL}
              element={<RequestRegisteringNewArabianHorseFoal key={'RequestRegisteringNewArabianHorseFoal'} />}
            />
            <Route
              path={RoutesName.REQUEST_OWNED_HORSES_CERTIFICATE}
              element={<RequestForOwnedEAHSRegisteredHorsesCertificate key={'RequestForOwnedEAHSRegisteredHorsesCertificate'} />}
            />
            <Route
              path={RoutesName.REQUEST_REGISTER_ARABIAN_HORSE_STUD}
              element={<RequestForRegistrationOfAnArabianHorseStud toast={toast} />}
            />
            <Route
              path={RoutesName.REQUEST_UPDATE_HORSE_DATA}
              element={<RequestToUpdateArabianHorseData key={'RequestToUpdateArabianHorseData'} />}
            />
            <Route
              path={RoutesName.REQUEST_HORSE_DEATH_DECLARATION}
              element={<RequestToDeclarationOfArabianHorseDeath key={'RequestToDeclarationOfArabianHorseDeath'} />}
            />
            <Route
              path={RoutesName.INACTIVE_HORSE_REGISTRATION_REQUEST}
              element={<InactiveHorseRegistrationRequest key={'InactiveHorseRegistrationRequest'} />}
            />
            <Route
              path={RoutesName.REQUEST_RACING_NAME_IMPORTED_HORSE}
              element={<RequestToAddARacingNameForAnImportedArabianHorse key={'RequestToAddARacingNameForAnImportedArabianHorse'} />}
            />
            <Route
              path={RoutesName.REQUEST_PASSPORT_DUPLICATE_DAMAGED}
              element={<ReqestForIssuingAnArabianHorsePassportDuplicateDamaged key={'ReqestForIssuingAnArabianHorsePassportDuplicateDamaged'} />}
            />
            <Route
              path={RoutesName.IMPORT_HORSE_FROZEN_SEMEN}
              element={<ImportHorseFrozenSemen key={'ImportHorseFrozenSemen'} />}
            />
            <Route
              path={RoutesName.IMPORT_HORSE}
              element={
                <PrivateRoute>
                  <ImportHorse key={'ImportHorse'} />
                </PrivateRoute>
              }
            />
            <Route
              path={RoutesName.GENETIC_DISORDER_TESTING}
              element={<GeneticDisorderTesting key={'GeneticDisorderTesting'} />}
            />
            <Route
              path={RoutesName.REQUEST_SEMEN_CERTIFICATE}
              element={<RequestSemenCertificate key={'RequestSemenCertificate'} />}
            />
            <Route
              path={RoutesName.EXPORT_HORSE}
              element={
                <PrivateRoute>
                  <ExportHorse key={'ExportHorse'} toast={toast} />
                </PrivateRoute>
              }
            />

            <Route
              path={RoutesName.CANCEL_EXPORT_HORSE}
              element={<CancelExportHorse key={'CancelExportHorse'} />}
            />

            <Route
              path={RoutesName.EXPORT_HORSE_SEMEN}
              element={<ExportHorseSemen key={'ExportHorseSemen'} />}
            />

            <Route
              path={RoutesName.PRESS_COVERAGE_REQUEST}
              element={<PressCoverageRequest key={'PressCoverageRequest'} />}
            />
            
            {/* 
              ===== IMPORTANT: Route Swap Configuration =====
              
              These two routes control which booking page shows data and which shows "Coming Soon".
              Only ONE configuration should be active at a time.

              --- Configuration A (Currently Active) ---
              OPEND_EVENTS → OpendBooking (no isAds)  →  "Table Reservation Packages" shows data
              OPEND_ADS    → OpendBooking (isAds=true) →  "Advertising Packages" shows data

              --- Configuration B (Currently Commented Out) ---
              OPEND_ADS    → OpendBooking (no isAds)  →  "Advertising Packages" shows data
              OPEND_EVENTS → OpendBooking (isAds=true) →  "Table Reservation Packages" shows data

              Swap between A and B to toggle which page in the header menu 
              displays data and which one shows "Coming Soon".

              You need to review book table button in show details page also.
            */}
            {/* Configuration A (Currently Active): */}
            {/* <Route
              path="/m-opend-events"
              element={<OpendBooking isMobileWebView={true} />}
            />
            <Route
              path="/m-opend-ads"
              element={<OpendBooking isMobileWebView={true} isAds={true} />}
            /> */}
            {/* Configuration B (uncomment to activate, and comment out Configuration A above): */}
            <Route
              path="/m-opend-ads"
              element={<OpendBooking isMobileWebView={true} />}
            />
            <Route
              path="/m-opend-events"
              element={<OpendBooking isMobileWebView={true} isAds={true} />}
            />
           
            <Route path="/m-book-table" element={<BookTable isAds={true} />} />
            <Route
              path="/m-ads-book-table"
              element={<BookTable isAds={true} />}
            />
            <Route
              path={RoutesName.SHOW_PARTICIPATE}
              element={

                <PrivateRoute>
                  <ShowParticipatePage key={'participation Page'} toast={toast} />
                </PrivateRoute>

              } />
            <Route
              path={RoutesName.AUCTION_PARTICIPATE}
              element={

                <PrivateRoute>
                  <AucitonEntryParticipate key={'participation Page'} toast={toast} />
                </PrivateRoute>

              }
            />
            <Route
              path={RoutesName.AUCTION_ENTRY_CHECKOUT_PAGE}
              element={<AuctionEntryCheckoutPage key={'AuctionEntryCheckoutPage Page'} toast={toast} />} />
            <Route
              path={RoutesName.CHULIBPAGE}
              element={<ChulibPage key={'CHULIB Page'} toast={toast} />} />
            <Route
              path={RoutesName.SEMENMARKET}
              element={<SemenMarketListPage key={'SEMENMARKET'} toast={toast} />} />
            <Route
              path={RoutesName.OWNERSSERVICEFORM}
              element={<OwnerServicesForm key={'OWNERSSERVICEFORM'} toast={toast} />} />
            <Route
              path={RoutesName.SEMENDETAILS}
              element={<SemenDetailsPage key={'SEMENDETAILS'} toast={toast} />} />
            <Route
              path={RoutesName.SEMENCHECKOUT}
              element={
                <PrivateRoute>
                  <SemenCheckoutPage key={'SEMENCHECKOUT'} toast={toast} />
                </PrivateRoute>
              }
            />
            <Route
              path={RoutesName.SEMENREQUESTS}
              element={<SemenRequestsPage key={'SEMENREQUESTS'} toast={toast} />} />
            <Route
              path={RoutesName.FONTS_COMPETITION_REGISTRATION}
              element={<FontCompetitionPage key={'OWNERSSERVICEFORM'} />} />
            <Route
              path={RoutesName.DIGITAL_CATALOG}
              element={<DigitalCatalog key={'digitalCatalog'} />} />
            <Route
              path={RoutesName.DISCIPLINARY_DECISIONS}
              element={<DisciplinaryDecisionsListPage key={'DisciplinaryDecisionsListPage'} />} />
            <Route
              path={RoutesName.DISCIPLINARY_DECISION_DETAILS}
              element={<DisciplinaryDecisionDetailsPage key={'DisciplinaryDecisionDetailsPage'} />} />
            <Route
              path={RoutesName.POLL}
              element={<PollPage key={'PollPage'} />} />
            <Route
              path={RoutesName.WORKSHOP_REGISTRATION}
              element={<WorkshopRegistrationPage key={'WorkshopRegistrationPage'} toast={toast} />} />

          </Routes>
        </CompleteProfileMiddleWare>

      </Layout>

    </Router>
  );
}

export default App;
